export const generateShortString = function (string) {
    if (!string)
        return "X";

    var usernameMatches = string.match(/\b(\w)/g);
    var shortName = usernameMatches[0];
    if (usernameMatches.length > 1)
        shortName += usernameMatches[1];
    return shortName.toUpperCase();
};